exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-breifing-tsx": () => import("./../../../src/pages/breifing.tsx" /* webpackChunkName: "component---src-pages-breifing-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-prologue-tsx": () => import("./../../../src/pages/prologue.tsx" /* webpackChunkName: "component---src-pages-prologue-tsx" */),
  "component---src-pages-targets-tsx": () => import("./../../../src/pages/targets.tsx" /* webpackChunkName: "component---src-pages-targets-tsx" */)
}

